<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Add a Daily Tip
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-menu
                v-model="tipDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.tip_date"
                    label="Tip Date *"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="formErrors.tip_date"
                    clearable
                    @click:clear="form.tip_date = null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.tip_date"
                  no-title
                  scrollable
                  @input="tipDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col sm="6">
              <v-switch
                v-model="form.is_active"
                label="Active"
                inset
                color="success"
              ></v-switch>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.title"
                outlined
                label="Title *"
                prepend-inner-icon="mdi-lightbulb-on-outline"
                :error-messages="formErrors.title"
                counter="150"
                maxlength="150"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.summary"
                outlined
                label="Summary"
                prepend-inner-icon="mdi-subtitles"
                :error-messages="formErrors.summary"
                counter="255"
                maxlength="255"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="form.description"
                outlined
                label="Description"
                prepend-inner-icon="mdi-text"
                :error-messages="formErrors.description"
                rows="5"
                counter
              ></v-textarea>
            </v-col>
          </v-row>

          <v-divider class="mt-5 mb-5"></v-divider>
          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            rounded
            color="primary"
            dark
            @click="save"
          >
            Save Daily Tip
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "@/axios";

export default {
  name: "DailyTipCreatePage",
  data() {
    return {
      form: {
        tip_date: null,
        title: "",
        summary: "",
        description: "",
        is_active: true,
      },
      formErrors: {},
      isLoading: false,
      tipDateMenu: false,
    };
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        this.formErrors = {};

        const response = await axios.post("/daily-tips", this.form);

        if (response.data.success) {
          this.$store.dispatch("errors/setSuccess", {
            message: "Daily tip created successfully",
          });
          this.$router.push("/daily-tips");
        } else {
          this.$store.dispatch("errors/setError", {
            message: response.data.message || "Failed to create daily tip",
          });
        }
      } catch (error) {
        console.error("Error creating daily tip:", error);

        if (error.response && error.response.status === 422) {
          this.formErrors = error.response.data.errors || {};
        } else if (error.response && error.response.status === 401) {
          this.$router.push("/login");
        } else {
          this.$store.dispatch("errors/setError", {
            message: "Error creating daily tip",
          });
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
